import { Box, Typography } from "@mui/material";
import { TABULAR_NUMERALS } from "../../general/dataAtoms/shared.ts";

export interface HeaderStat {
  label: string;
  // already formatted for display
  value: string;
  // a resolved colour, or an MUI palette path such as "text.secondary"; a
  // figure that is neither good nor bad has none and stays in ink
  color?: string;
}

/**
 * Chart heading: title and subtitle on the left, an optional row of headline
 * statistics on the right, which goes under them where the two do not fit
 * side by side.
 */
export const ChartHeaderStats = ({
  title,
  subtitle,
  stats = [],
}: {
  title: string;
  subtitle: string;
  stats?: readonly HeaderStat[];
}) => (
  <Box
    sx={{
      display: "flex",
      alignItems: "flex-end",
      justifyContent: "space-between",
      flexWrap: "wrap",
      columnGap: 3.5,
      rowGap: 1,
    }}
  >
    <Box>
      <Typography variant="subtitle2" component="h4" sx={{ fontWeight: 700 }}>
        {title}
      </Typography>
      <Typography variant="body2" sx={{ mt: 0.375, color: "text.secondary" }}>
        {subtitle}
      </Typography>
    </Box>
    {stats.length > 0 && (
      <Box sx={{ display: "flex", gap: 3.5 }}>
        {stats.map((stat) => (
          <Box key={stat.label} sx={{ textAlign: "right" }}>
            <Typography
              variant="caption"
              sx={{
                display: "block",
                fontWeight: 500,
                color: "text.secondary",
              }}
            >
              {stat.label}
            </Typography>
            <Typography
              variant="h5"
              component="p"
              sx={{
                fontWeight: 700,
                letterSpacing: "-.015em",
                lineHeight: 1.25,
                color: stat.color,
                ...TABULAR_NUMERALS,
              }}
            >
              {stat.value}
            </Typography>
          </Box>
        ))}
      </Box>
    )}
  </Box>
);
